<ts-dialog title="Add View" (closeDialog)="matDialogRef.close()">
  <form [formGroup]="viewForm" ts-dialog-body>
    <mat-form-field class="subject">
      <mat-label>View Name</mat-label>
      <input matInput formControlName="name" />
      @if (viewForm.get('name').hasError('duplicateName')) {
        <mat-error> This name already exists. Please choose a different name. </mat-error>
      }
    </mat-form-field>
  </form>
  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="matDialogRef.close()">Cancel</ts-button>
    <ts-button
      variant="primary"
      [disabled]="viewForm.disabled || viewForm.pristine || viewForm.invalid"
      (click)="save()"
      >Save</ts-button
    >
  </div>
</ts-dialog>
